const ROUTES = {
  HOME: '/',
  PAGE_NOT_FOUND: '*',
  LOGIN: '/login',
};

export default ROUTES;
